var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftTurn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 16.9706,
    height: 16.9706,
    rx: 0.754255,
    transform: "rotate(-45 0 12)",
    fill: "#FEDF12"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.261674,
    y: 12.0002,
    width: 16.5934,
    height: 16.5934,
    rx: 0.628546,
    transform: "rotate(-45 0.261674 12.0002)",
    fill: "#FEDF12",
    stroke: "black",
    strokeWidth: 0.251418
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8127 17.6728H14.2986V10.9789H10.2759C10.2969 11.0627 10.4142 11.4629 10.7159 12.3931C10.8542 13.2856 10.2707 13.1631 9.96165 12.9902L5.15332 9.73752C6.46278 8.79471 9.26397 6.8211 9.99307 6.46912C10.7222 6.11713 10.7787 6.6472 10.7159 6.95623L10.2759 8.4333H15.6499C16.4796 8.49616 16.7708 9.17184 16.8127 9.50182V17.6728Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.0314273
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftTurn);
export default __webpack_public_path__ + "static/media/leftTurn.fcaf9effa952bfd5674164d75f227a9a.svg";
export { ForwardRef as ReactComponent };